import _ from 'lodash';

export const rts = {
  handleGo_next: 'handleGo_next',
  handleGo_back: 'handleGo_back',
  handleGo_backTo: 'handleGo_backTo',
  handleGo_replace: 'handleGo_replace',
  handleSet_value: 'handleSet_value',
  handleReset_value: 'handleReset_value',
  handleShow_commit: 'handleShow_commit',
  handleClose_diffs: 'handleClose_diffs',
  handleAmmend_updateViewItemsInViews: 'handleAmmend_updateViewItemsInViews'
};

export const squaresInitialState = (baseline, isGlobal, pageView, view, viewKey, menuAuthGroups, _basePageView) => ({
  baseline: _.cloneDeep(baseline), // never mutate this
  apsGlobal: _.cloneDeep(baseline.aps_global),
  apsViewItems: _.cloneDeep(baseline.aps_viewItems),
  apsViews: _.cloneDeep(baseline.aps_views),
  isGlobal,
  view,
  viewKey,
  pageView,
  direction: 'left',
  allGroups: [_.cloneDeep(menuAuthGroups)]
});

const _appPathTypes = {
  global: 'global',
  viewItems: 'viewItems',
  views: 'views',
}

export const squaresReducer = (state, action) => {

  const { type, value, cp, cpf } = action;
  const { isGlobal, pageView } = state

  switch (type) {

    case rts.handleGo_next:
      let currentViProps;
      if (action.item.props && action.parentGroupKey === 'views') {
        currentViProps = _.keys(action.item.props)
      }
      const _allGroups = [
        ...state.allGroups,
        {
          ...action.item,
          parentGroupKey: action.parentGroupKey || null,
          isParentItem: action.item.childItems ? true : false,
          isChildItem: state.allGroups[_.size(state.allGroups) - 1]?.isParentItem
        }
      ]
      const _keyIgnores = isGlobal ? [] : ['pageOptions', 'view']

      // const keyPath = _allGroups
      //   .map(({ key }) => key)
      //   .filter(Boolean)
      //   .filter(key => !_keyIgnores.includes(key))
      //   .join('.')

      const keyPath = _allGroups
        .map(({ key }) => key)
        .filter(Boolean)
        .filter(key => !_keyIgnores.includes(key))
        .slice(isGlobal ? 1 : 0)
        .join('.')

      console.log('keyPath', keyPath)

      return {
        ...state,
        allGroups: _allGroups,
        direction: 'right',
        currentViProps,
        keyPath,
      }

    case rts.handleGo_replace:
      console.log('_replacementGroup', action.replacementGroup, action.currentGroup)
      return { ...state }

    case rts.handleGo_back:
      if (state.allGroups.length <= 1) { return state }
      return { ...state, allGroups: state.allGroups.slice(0, -1), direction: 'left', }

    case rts.handleGo_backTo:
      const { index } = action;
      if (index < 0 || index >= state.allGroups.length) return state
      if (state.allGroups.length <= 1) return state // ⛔ root protected 
      return {
        ...state,
        allGroups: state.allGroups.slice(0, index + 1)
      }

    case rts.handleAmmend_updateViewItemsInViews:
      return updateViewItemsInViews(state, action.items)

    case rts.handleSet_value: {
      let _cp = isGlobal ? state.keyPath : `${state.pageView}.${state.keyPath}`
      const _cps = _cp ? _cp.split('.') : []
      // const _isViewItem = _cp ? _cp.split('.')[0] === 'views' : false // determine which source 

      const _isViewItem = isGlobal && _cps[0] === 'views'
      const _isView = !isGlobal && _.includes(_cps, 'view')

      const _appPathType = isGlobal ? _isViewItem ? _appPathTypes.viewItems : _appPathTypes.global : _appPathTypes.views

      console.group('set value', _appPathType)
      console.log('isGlobal', isGlobal)
      console.log('_isViewItem', _isViewItem)
      console.log('_isView', _isView)
      console.log('keyPath new', _cp)
      console.log('keyPath old', cp)
      console.log('value', value)

      const nextState = _.cloneDeep(state);

      switch (_appPathType) {
        case _appPathTypes.global:
          _.set(nextState.apsGlobal, _cp, value);
          break;
        case _appPathTypes.viewItems:
          _cp = removeFromStart(_cp, 1)
          _.set(nextState.apsViewItems, _cp, value);
          break;
        case _appPathTypes.views:
          _.set(nextState.apsViews, _cp, value);
          break;
      }

      const { _diffs, diffCount } = getDiffs(nextState)
      console.log('_diffs', diffCount)
      console.log('diffCount', _diffs)
      console.log('nextState.apsViews', nextState.apsViews)

      console.groupEnd()

      // const isViewItem = cpf.includes('views'); // determine which source 
      // const isView = cpf.includes('view') || cpf.includes('pageOptions'); // determine which source 
      // // determine which object to update based on path prefix 
      // if (isGlobal) {
      //   if (!isViewItem) {
      //     // _.set(nextState.apsGlobal, cp.replace(/^apsGlobal\.|^aps_global\./, ''), value);
      //     _.set(nextState.apsGlobal, cp, value);
      //     console.log('next apsGlobal', cp, _.get(nextState.apsGlobal, cp, {}))
      //   } else if (isViewItem) {
      //     // _.set(nextState.apsViewItems, cp.replace(/^apsViewItems\.|^aps_viewItems\./, ''), value);
      //     _.set(nextState.apsViewItems, cp, value);
      //     console.log('next apsViewItems', cp, _.get(nextState.apsViewItems, cp, {}))
      //     // console.log('next apsViewItems', nextState.aps_viewItems)
      //   }
      // } else if (isView) {
      //   _.set(nextState.apsViews, cp, value);
      //   console.log('next apsViews', cp, _.get(nextState.apsViews, cp, {}))
      //   // _.set(nextState.apsViews, cp.replace(/^apsViews\.|^aps_views\./, ''), value);
      // }
      return { ...nextState, dataHasChanged: true, _diffs, diffCount };
    }


    case rts.handleReset_value: {
      const baseline = _.cloneDeep(state.baseline);
      return {
        baseline,
        apsGlobal: _.cloneDeep(baseline.aps_global),
        apsViewItems: _.cloneDeep(baseline.aps_viewItems),
        apsViews: _.cloneDeep(baseline.aps_views),
        diffCount: 0,
        showCommit: false,
        diffs: null,
        dataHasChanged: false
      };
    }

    case rts.handleShow_commit: {
      const { _diffs, diffCount } = getDiffs(state)
      return {
        ...state,
        diffs: _diffs,
        diffCount: diffCount,
        showCommit: true,
      }
    }

    case rts.handleClose_diffs:
      return { ...state, showCommit: false }

    default:
      return state;
  }
};

// Handlers for use with dispatch
export const squaresHandlers = (dispatch) => ({
  handleGo_next: (item, parentGroupKey) => dispatch({ type: rts.handleGo_next, item, parentGroupKey }),
  handleGo_back: () => dispatch({ type: rts.handleGo_back }),
  handleGo_replace: (replacementGroup, currentGroup) => dispatch({ type: rts.handleGo_replace, replacementGroup, currentGroup }),
  handleGo_backTo: (index) => dispatch({ type: rts.handleGo_backTo, index }),
  handleSet_value: (value, cp, cpf) => dispatch({ type: rts.handleSet_value, value, cp, cpf }),
  handleReset_value: () => dispatch({ type: rts.handleReset_value }),
  handleShow_commit: () => dispatch({ type: rts.handleShow_commit }),
  handleClose_diffs: () => dispatch({ type: rts.handleClose_diffs }),
  handleAmmend_updateViewItemsInViews: (items) => dispatch({ type: rts.handleAmmend_updateViewItemsInViews, items }),
});

const getDiff = (obj, base) =>
  _.transform(obj, (result, value, key) => {
    if (!_.isEqual(value, base[key])) {
      result[key] =
        _.isObject(value) && _.isObject(base[key])
          ? getDiff(value, base[key])
          : value;
    }
  }, {});

const diffToFirestoreUpdate = (diff, basePath = '') => {
  return _.transform(diff, (result, value, key) => {
    const path = basePath ? `${basePath}.${key}` : key;

    // recurse ONLY for plain objects
    if (_.isPlainObject(value)) {
      Object.assign(result, diffToFirestoreUpdate(value, path));
    } else {
      // arrays + primitives are leaf updates
      result[path] = value;
    }
  }, {});
};

const getItemPositions = (items) => {
  const updates = items.reduce((acc, item, index) => {
    acc[item.key] = {
      position: index,
    };
    return acc;
  }, {});
  return updates
}

const updateViewItemsInViews = (state, items) => {
  const nextState = _.cloneDeep(state);
  const _cp = `${state.pageView}.${state.keyPath}`
  const updates = getItemPositions(items)
  _.forEach(updates, (update, updateKey) => {
    const path = `${_cp}.${updateKey}`;
    const existing = _.get(nextState.apsViews, path, {});
    _.set(nextState.apsViews, path, { ...existing, ...update });
  });
  const { _diffs, diffCount } = getDiffs(nextState)
  return { ...nextState, _diffs, diffCount }
}

const getDiffs = (state) => {
  const diffs_g = getDiff(state?.apsGlobal, state?.baseline.aps_global)
  const diffs_vi = getDiff(state?.apsViewItems, state?.baseline.aps_viewItems)
  const diffs_v = getDiff(state?.apsViews, state?.baseline.aps_views)
  const update_global = { ...diffToFirestoreUpdate(diffs_g) }
  const update_viewItems = { ...diffToFirestoreUpdate(diffs_vi) }
  const update_views = { ...diffToFirestoreUpdate(diffs_v) }

  const sections = [
    { key: 'global', stateKey: 'apsGlobal', baselineKey: 'aps_global' },
    { key: 'viewItems', stateKey: 'apsViewItems', baselineKey: 'aps_viewItems' },
    { key: 'views', stateKey: 'apsViews', baselineKey: 'aps_views' },
  ];

  const _diffs = { dataToUpdate: {}, data: {} };

  sections.forEach(({ key, stateKey, baselineKey }) => {
    const diffs = getDiff(state?.[stateKey], state?.baseline?.[baselineKey]);
    const update = diffToFirestoreUpdate(diffs);

    if (!_.isEmpty(update)) {
      _diffs.dataToUpdate[key] = update;
      _diffs.data[key] = diffs;
    }
  });

  return { _diffs, diffCount: _.size(update_global) + _.size(update_viewItems) + _.size(update_views) }
}

const dataToUpdate = {
  'display.hideSelectedPropsAndSections': true,
  'display.ignoreEmptyDateProps': true,
  'display.showAllLinks': false,
  'display.showDataLinks': false,
  'display.showPageTypeBreadcrumb': true,
  'display.showTmz': true,
  'imageOptions.hideOnSubLists': true,
  'imageOptions.imageLocation': "bottomRight",
  'themeColors.color3': "#a12424",
  'themeColors.color4': "#3819dd",
  'selectedItems': ['one', 'two', 'three']
}


const removeFromStart = (str, count) =>
  str
    ? str.split('.').slice(count).join('.')
    : ''
